import { render, staticRenderFns } from "./ParametrizacaoAcaoList.vue?vue&type=template&id=68d4a851&lang=html"
import script from "./ParametrizacaoAcaoList.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoAcaoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports